import { createAction } from '@reduxjs/toolkit';
import { UnfoldedSkinsData } from './init-state';

export const fetchChatSkinningData = createAction('chatSkinning/fetch');
export const chatSkinningDataFetched = createAction<{ data: UnfoldedSkinsData }>('chatSkinning/fetched');
export const setIsChatSkinningDataLoading = createAction<{ isLoading: boolean }>('chatSkinning/setIsLoading');
